<section class="layout py-12 lg:py-24 text-gray-500" id="centers">

  <div class="bg-white">
    <div class="mx-auto">
      <div class="mx-auto max-w-4xl"><h2
        class="text-2xl font-bold leading-10 tracking-tight text-gray-500">{{ 'faq' | translate }}</h2>
        @for (faqGroup of faqService.faqsGrouped(); track faqGroup[0]) {
          <h2
            class="mt-10 mb-5 text-xl font-bold leading-10 tracking-tight text-gray-500">{{ 'faq/' + faqGroup[1]?.[0]?.id + '/category' | translate }}</h2>
          @for (faq of faqGroup[1]; track faq.id) {
            <dl class="space-y-6 border-t border-gray-200 divide-y divide-gray-500/10">
              <div class="py-5">
                <dt> <!-- Expand/collapse question button -->


                  @if (expanded.has(faq.id)) {
                    <button type="button" class="flex w-full items-start justify-between text-left text-gray-500"
                            aria-controls="faq-0" aria-expanded="false" (click)="expanded.delete(faq.id)"><span
                      class="text-base font-semibold leading-7">{{ 'faq/' + faq.id + '/question' | translate }}</span>
                      <span class="ml-6 flex h-7 items-center">
                        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor" aria-hidden="true"
                             (keyup.enter)="emulateClick($event)">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6"/>
                        </svg>
                             </span>
                    </button>
                  } @else {
                    <button type="button" class="flex w-full items-start justify-between text-left text-gray-500"
                            aria-controls="faq-0" aria-expanded="false" (click)="expanded.add(faq.id)"><span
                      class="text-base font-semibold leading-7">{{ 'faq/' + faq.id + '/question' | translate }}</span>
                      <span class="ml-6 flex h-7 items-center">
                        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                             aria-hidden="true"
                             (keyup.enter)="emulateClick($event)">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6"/>
                        </svg>
                             </span>
                    </button>
                  }

                </dt>

                @if (expanded.has(faq.id)) {
                  <dd class="mt-2 pr-12" id="faq-0">
                    <app-inner-html classes="text-base leading-7 text-gray-600"
                                    [html]="faqService.translate(centerService.center()?.id, faq.id)">

                    </app-inner-html>
                  </dd>
                }
              </div>
            </dl>
          }
        }
      </div>
    </div>
  </div>
</section>

<div class="bg-beige">

  <div class="layout py-12">
    <h2
      class="text-2xl font-bold leading-10 tracking-tight text-gray-500">{{ 'noSolution' | translate }}</h2>
    <p>{{ 'noSolutionDescription' | translate }}</p>
  </div>
  <app-contact/>
</div>
